export const BulletTick = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#ECF5F9" />
    <path
      d="M5.80762 12.5384L9.84608 16.3077L18.1922 7.42307"
      stroke="#311B77"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
